import React from 'react';
import { Link } from 'react-router-dom';

export default function OrderComplete() {
  return (
    <div className="page-container">
      <header className="page-header">
        <h1>Order Complete</h1>
        <p>Thank you! Your order has been received.</p>
      </header>
      <main className="page-content" style={{ textAlign:'center' }}>
        <p>We sent a confirmation to your email and will contact you if needed.</p>
        <div className="form-actions" style={{ justifyContent:'center' }}>
          <Link to="/shop" className="button">Continue Shopping</Link>
          <Link to="/orders" className="button" style={{ marginLeft: 12 }}>View Orders</Link>
        </div>
      </main>
    </div>
  );
}


